import BaseEntity from '../baseclasses/BaseEntity'
export class EquipmentGraphics extends BaseEntity{
    ID?: number;
    Code?: string;
    Name?: string;
    Inactive: boolean;
    FullName?: string;
}

export default EquipmentGraphics;